import { CARAVAN_TRIP, type TripStage } from '../config/trip'
import { tripClockParts, tripDateKey } from './tripTime'

export type JourneyMoment =
  | { phase: 'before'; productDay: string; stage: TripStage; daysUntilStart: number }
  | { phase: 'stage'; productDay: string; stage: TripStage; tripDay: number }
  | { phase: 'transition'; productDay: string; stage: TripStage; nextStage: TripStage; tripDay: number }
  | { phase: 'after'; productDay: string; stage: TripStage }

function calendarDaysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000)
}

export function journeyMoment(now = new Date()): JourneyMoment {
  const productDay = tripDateKey(now)
  const firstStage = CARAVAN_TRIP.stages[0]
  const lastStage = CARAVAN_TRIP.stages.at(-1)
  if (!firstStage || !lastStage) throw new Error('Le voyage ne contient aucune étape.')
  if (productDay < CARAVAN_TRIP.startsOn) {
    return { phase: 'before', productDay, stage: firstStage, daysUntilStart: calendarDaysBetween(productDay, CARAVAN_TRIP.startsOn) }
  }
  if (productDay > CARAVAN_TRIP.endsOn) return { phase: 'after', productDay, stage: lastStage }

  const parts = tripClockParts(now)
  const nextStage = CARAVAN_TRIP.stages.find((stage) => stage.startsOn === productDay && stage.order > 1)
  const previousStage = nextStage ? CARAVAN_TRIP.stages.find((stage) => stage.order === nextStage.order - 1) : undefined
  const tripDay = calendarDaysBetween(CARAVAN_TRIP.startsOn, productDay) + 1
  if (nextStage && previousStage && parts.hour < 12) {
    return { phase: 'transition', productDay, stage: previousStage, nextStage, tripDay }
  }
  const stage = [...CARAVAN_TRIP.stages].reverse().find((candidate) => candidate.startsOn <= productDay && productDay <= candidate.endsOn) ?? lastStage
  return { phase: 'stage', productDay, stage, tripDay }
}

export function journeyHeroLine(moment: JourneyMoment): string {
  if (moment.phase === 'before') return moment.daysUntilStart === 1 ? 'Départ demain' : `Départ dans ${String(moment.daysUntilStart)} jours`
  if (moment.phase === 'after') return 'Le voyage est terminé'
  if (moment.phase === 'transition') return `En route vers ${moment.nextStage.name}`
  return `Jour ${String(moment.tripDay)} du voyage`
}
